module.exports = __webpack_public_path__ + "static/media/Mountain-bike-frame-size.1e040590.png";